export const SET_LOCALE = 'SET_LOCALE';

export const setLocale = locale => ({
  type: SET_LOCALE,
  locale,
});
